import React, { Component } from 'react'

import PropTypes from 'prop-types'
import PieChart from 'recharts/es6/chart/PieChart'
import Cell from 'recharts/es6/component/Cell'
import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer'
import Pie from 'recharts/es6/polar/Pie'

import { dataToGaugePercentage } from '../../../../utils/resumesearch/dataTransformation'

class GaugeChart extends Component {
  static propTypes = {
    chartData: PropTypes.any.isRequired,
    COLORS: PropTypes.array,
    outerRadius: PropTypes.any,
    innerRadius: PropTypes.any,
    textBottom: PropTypes.bool,
  }
  static defaultProps = {
    COLORS: ['#5099DE', 'gray'],
    outerRadius: '100%',
    innerRadius: '80%',
    centerFontSize: 40,
    textBottom: false,
  }

  render() {
    const {
      chartData,
      COLORS,
      outerRadius,
      innerRadius,
      textBottom,
    } = this.props
    return (
      <ResponsiveContainer>
        <PieChart>
          <text
            id={textBottom ? 'gaugeLabelSmall' : 'gaugeLabelLarge'}
            style={{ width: '100%' }}
            x={'50%'}
            y={'50%'}
            dy={8}
            textAnchor="middle"
            fill={'Black'}
          >
            {dataToGaugePercentage(chartData)}%
          </text>

          <Pie
            dataKey="value"
            data={chartData}
            startAngle={225}
            endAngle={-45}
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            paddingAngle={0}
          >
            {chartData &&
              chartData.map((entry, index) => (
                <Cell key={entry} fill={COLORS[index % COLORS.length]} />
              ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    )
  }
}

export default GaugeChart



// WEBPACK FOOTER //
// ./src/components/ui/charts/recharts/GaugeChart.js